<template>
    <div
        class="position-relative w-100 font-14"
        :class="{
            'text-white': store.data.selected.poi,
            'text-blue': !store.data.selected.poi
        }"
    >
        <div
            class="position-absolute top-50pc left-0 d-flex align-items-center font-16 translate-t-n50pc se-main__dropdown-header-icon-left"
            :class="{
                'text-light-blue': !store.data.selected.poi
            }"
            slot="icon-left"
        >
            <span class="tf-icon-visites"></span>
        </div>
        <select
            class="w-100 border-0 text-blue weight-500 text-elipsis cursor-pointer outline-none appearance-none se-main__dropdown-header"
            :class="{
                ...(classesSelect || {}),
                'text-white font-weight-bold bg-light-blue': store.data.selected.poi
            }"
            :value="store.data.selected.poi"
            @change="(e) => select(e.target.value)"
        >
            <option class="se-main__dropdown-option" value="">
                {{ store.contents.poi }}
            </option>
            <option class="se-main__dropdown-option" v-for="(poi, poi_i) in pois" :value="poi" :key="poi_i">
                {{ poi.label }}
            </option>
        </select>
        <div
            class="position-absolute top-50pc right-0 align-items-center mr-2 font-22 cursor-pointer translate-t-n50pc"
            :class="{
                'd-flex': store.data.selected.poi,
                'd-none': !store.data.selected.poi
            }"
            @click="clear"
        >
            <i class="far fa-times-circle"></i>
        </div>
        <div
            class="position-absolute top-50pc right-0 align-items-center mr-2 translate-t-n50pc"
            :class="{
                'd-flex': !store.data.selected.poi,
                'd-none': store.data.selected.poi
            }"
        >
            <i class="fas fa-caret-down"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Poi',
    components: {},
    props: {
        store: Object,
        classesSelect: Object,
        filter: Object
    },
    data() {
        return {
            controls: {},
            data: {},
            off: {},
            state: {
                filter: ''
            }
        }
    },
    computed: {
        se() {
            return this.store.libs.se
        },
        pois() {
            // if (!this.store.data.geoData || !this.store.data.available) {
            //     return [];
            // }
            // const pois = this.filter.items.filter((poi) => {
            //     console.log('poi: ', poi)
            //     return poi.isAvailable.criterias.length > 0
            // })
            // console.log("pois :>> ", pois);
            return this.filter.items
        }
    },
    methods: {
        select(poiId) {
            // console.log("select", poiId);
            this.store.data.selected.poi = poiId
            this.store.libs.se.batch(() => {
                this.store.libs.se.setFieldValue('region', undefined)
                this.store.libs.se.setFieldValue('domaineSki', undefined)
                this.store.libs.se.setFieldValue('station', undefined)
                this.store.libs.se.setFieldValue('parentStation', undefined)
                this.store.libs.se.setFieldValue('beginDate', undefined)
                this.store.libs.se.setFieldValue('endDate', undefined)
            })
            // this.se.batch(() => {
            //     this.se.setFieldValue("parentStation", undefined);
            //     this.se.setFieldValue("station", undefined);
            //     this.se.setFieldValue("domaineSki", domainId);
            // });
        },
        clear() {
            this.store.data.selected.poi = null
        }
    },
    mounted() {
        // console.log("this.store :>> ", this.store.data, this.filter);
    }
}
</script>
<style scoped></style>
